import {
  ENDPOINT_ORDERS,
  ENDPOINT_ROOT,
  ENDPOINT_SHIPPING_REQUEST,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const postShippingRequest = ({ orderId, items, hasNoSelection, comment }) => {
  const params = {
    order_lines: items,
    has_no_selection: hasNoSelection,
    comment,
  };

  return axiosAuth
    .post(
      `${ENDPOINT_ROOT}/${ENDPOINT_ORDERS}/${orderId}/${ENDPOINT_SHIPPING_REQUEST}`,
      params,
    )
    .then((res) => res.data);
};

export default postShippingRequest;
